<template>
    <div v-if="title" class="trip-headsign d-flex flex-column text-truncate" :class="themeClasses">
        <div class="d-flex flex-row align-center text-truncate">
            <div class="trip-headsign__title text-truncate" v-text="title"></div>
            <slot name="appendIcon">
                <v-icon v-if="icon" :icon="icon" :size="iconSize" class="ml-1 flex-shrink-0" />
            </slot>
        </div>
        <div v-if="subtitle" class="trip-headsign__subtitle text-truncate" v-text="subtitle"></div>
    </div>
</template>

<script setup lang="ts">
import { useTheme } from 'vuetify';

interface Props {
    title: string;
    subtitle?: string;
    icon?: string;
    iconSize?: number | string;
}

defineProps<Props>();
const { themeClasses } = useTheme();
</script>

<style lang="scss">
@use 'vuetify/settings' as *;
@use 'vuetify/lib/styles/tools/index' as tools;

.trip-headsign {
    --title-font-size: #{calc(16px / $font-size-root) * 1rem};
    --subtitle-font-size: #{calc(14px / $font-size-root) * 1rem};

    &__title {
        $-font-size: var(--title-font-size);
        $-letter-spacing: tools.map-deep-get($typography, 'h6', 'letter-spacing');
        $-line-height: tools.map-deep-get($typography, 'h6', 'line-height');
        $-text-transform: tools.map-deep-get($typography, 'h6', 'text-transform');
        @include tools.typography($-font-size, 500, $-letter-spacing, $-line-height, $-text-transform);
    }

    &__subtitle {
        $-font-size: var(--subtitle-font-size);
        $-letter-spacing: tools.map-deep-get($typography, 'body-2', 'letter-spacing');
        $-text-transform: tools.map-deep-get($typography, 'body-2', 'text-transform');
        color: var(--v-color-grey-darken-3);
        @include tools.typography($-font-size, 400, $-letter-spacing, 1.1, $-text-transform);
    }
}
</style>
